import axios from "../../axios-instance";

class ModalDialog {
  constructor(args) {
    this.params = Object.assign({}, args);
  }

  getTemplate() {
    const requestParam = {
      url: this.params.method,
      method: 'GET'
    };
    return axios(requestParam)
      .then(response => {
        if (response.data) {
          document.body.insertAdjacentHTML('beforeend', response.data);
          return true;
        } else {
          return false;
        }
      })
      .then(resp => {
        if (resp) {
          this.bindCloseBtn();
          if (typeof this.params.submitAction !== 'undefined') {
            this.bindActionBtn();
          }
          return true;
        }
      })
      .catch(() => {});
  }

  bindCloseBtn() {
    const closeBtns = document.querySelectorAll('.js-modal-close-btn, .js-modal-cancel-btn');
    for(let elem of closeBtns) {
      elem.addEventListener('click', () => {
        this.destroyModalBox();
      });
    }
  }

  bindActionBtn() {
    const actionBtn = document.querySelector('.js-modal-action-btn');
    actionBtn.addEventListener('click', () => {
      this.params.submitAction();
    });
  }

  destroyModalBox() {
    const modalParts = document.querySelectorAll('.js-modal-box');
    for(let el of modalParts) {
      el.remove();
    }
  }
}

class LocalModalDialog extends ModalDialog {
  constructor(args) {
    super(args);
  }

  getTemplate() {
    const loadDialogPromise = new Promise((resolve, reject) => {
      document.body.insertAdjacentHTML('beforeend', this.params.dialogData);
      this.bindCloseBtn();
      resolve(this);
    });
    return loadDialogPromise;
  }
}
export {ModalDialog};
export {LocalModalDialog};
